<template>
    <div class="IperMatrizPeligrosSector">
        <div v-if="sector">{{ sector }}</div>
        <div v-else><i class="fas fa-minus"></i></div>
    </div>
</template>

<script>
export default {
    name: "IperMatrizPeligrosSector",

    props: {
        sector: String
    }
}
</script>